import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Mailboxes from './pages/Mailboxes';
import Transactions from './pages/Transactions';
import { Groups, Services, Users, Reports } from './pages/OtherPages';
import SchemeCodes from './pages/SchemeCodes';
import IpbmRate   from './pages/IpbmRate';
import './index.css';

// Role definitions — single source of truth
// L1: dashboard only
// L2: dashboard + transactions + reports
// L3/L4: full access
export const ROLES = {
  DASHBOARD:     1,  // all levels
  LOGS:          2,  // L2+
  FULL_ACCESS:   3,  // L3+
};

function RequireLevel({ level, children }) {
  const { user } = useAuth();
  if ((user?.accesslevel ?? 0) < level) {
    return (
      <div style={{ padding: 40 }}>
        <div className="alert alert-error">
          <strong>Access Denied</strong> — this page requires access level {level} or above.
          Your current level is {user?.accesslevel ?? 0}.
        </div>
      </div>
    );
  }
  return children;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Layout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />

            {/* L1+ */}
            <Route path="/dashboard" element={
              <RequireLevel level={ROLES.DASHBOARD}><Dashboard /></RequireLevel>
            } />

            {/* L2+ */}
            <Route path="/transactions" element={
              <RequireLevel level={ROLES.LOGS}><Transactions /></RequireLevel>
            } />
            <Route path="/reports" element={
              <RequireLevel level={ROLES.LOGS}><Reports /></RequireLevel>
            } />

            {/* L3+ */}
            <Route path="/mailboxes" element={
              <RequireLevel level={ROLES.FULL_ACCESS}><Mailboxes /></RequireLevel>
            } />
            <Route path="/groups" element={
              <RequireLevel level={ROLES.FULL_ACCESS}><Groups /></RequireLevel>
            } />
            <Route path="/services" element={
              <RequireLevel level={ROLES.FULL_ACCESS}><Services /></RequireLevel>
            } />
            <Route path="/users" element={
              <RequireLevel level={ROLES.FULL_ACCESS}><Users /></RequireLevel>
            } />
            <Route path="/maintenance/scheme-codes" element={
              <RequireLevel level={ROLES.FULL_ACCESS}><SchemeCodes /></RequireLevel>
            } />
            <Route path="/maintenance/ipbm-rate" element={
              <RequireLevel level={ROLES.FULL_ACCESS}><IpbmRate /></RequireLevel>
            } />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </ThemeProvider>
  );
}
